export const UserAdminFilterKey = {
  Roles: 'roles',
  VerificationStatus: 'identity.verificationStatus',
} as const;
export type UserAdminFilterKey = (typeof UserAdminFilterKey)[keyof typeof UserAdminFilterKey];
export const USER_ADMIN_FILTER_KEYS = [
  UserAdminFilterKey.Roles,
  UserAdminFilterKey.VerificationStatus,
] as const;
